import React from 'react';
import Layout from '../components/Layout';
import './Pricing.css';

const pricingPlans = [
  {
    name: 'Free',
    price: '$0',
    period: 'forever',
    description: 'Perfect for trying out Tonometer Scan',
    features: [
      'Limited daily scans',
      'Basic blood pressure tracking',
      'Apple Health integration',
      'Privacy-first design'
    ],
    cta: 'Get Started',
    ctaLink: 'https://apps.apple.com/app/tonometer-scan',
    popular: false
  },
  {
    name: 'Premium',
    price: 'From $0.99',
    period: 'per month',
    description: 'Unlock unlimited scans and support development',
    features: [
      'Unlimited daily scans',
      'Advanced analytics & insights',
      'Export data to PDF',
      'Priority support',
      'Support future development',
      'All premium features unlocked'
    ],
    cta: 'View in App Store',
    ctaLink: 'https://apps.apple.com/app/tonometer-scan',
    popular: true
  }
];

const subscriptionTiers = [
  {
    name: 'Monthly',
    price: '$0.99',
    period: 'per month',
    description: 'Perfect for trying out premium features'
  },
  {
    name: '6 Months',
    price: '$4.99',
    period: 'every 6 months',
    description: 'Save 16% - Best for regular users',
    savings: 'Save 16%'
  },
  {
    name: 'Annual',
    price: '$9.99',
    period: 'per year',
    description: 'Save 16% - Best value for committed users',
    savings: 'Save 16%'
  }
];

const Pricing = () => {

  return (
    <Layout>
      <section className="pricing-section">
        <div className="pricing-header">
          <h1>Simple, Transparent Pricing</h1>
          <p>Subscription plans available in the app. Choose the plan that works best for your blood pressure monitoring needs.</p>
        </div>

        <div className="pricing-plans">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && <div className="popular-badge">Most Popular</div>}
              <div className="plan-header">
                <h3>{plan.name}</h3>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>
              
              <ul className="plan-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <span className="checkmark">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <a 
                href={plan.ctaLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className={`plan-cta ${plan.popular ? 'cta-primary' : 'cta-secondary'}`}
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>

        <div className="subscription-tiers">
          <h2>Premium Subscription Options</h2>
          <p>Available in the App Store. Choose the billing frequency that works best for you</p>
          
          <div className="tiers-grid">
            {subscriptionTiers.map((tier, index) => (
              <div key={index} className="tier-card">
                <h4>{tier.name}</h4>
                <div className="tier-price">
                  <span className="price">{tier.price}</span>
                  <span className="period">{tier.period}</span>
                </div>
                {tier.savings && (
                  <div className="savings-badge">{tier.savings}</div>
                )}
                <p className="tier-description">{tier.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="pricing-footer">
          <p>
            <strong>All plans include:</strong> Privacy-first design, Apple Health integration, 
            and secure on-device processing. No hidden fees, cancel anytime.
          </p>
          <p>
            <strong>Note:</strong> Subscriptions are managed through the App Store. 
            Download the app to start your subscription.
          </p>
          <p>
            <strong>Questions?</strong> Contact us at{' '}
            <a href="mailto:support@tonometer-scan.app">support@tonometer-scan.app</a>
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Pricing;

